import { PluginCard, PluginCardCommonProps } from '../../../plugins-tab/PluginCard';
import { PluginMeddpiccSvg } from '../../icons';
import { meddpiccTexts } from './texts';

export const MeddpiccPluginCard = (props: PluginCardCommonProps) => {
  return (
    <PluginCard
      svgIcon={<PluginMeddpiccSvg />}
      title={meddpiccTexts.title}
      description={meddpiccTexts.description}
      {...props}
    />
  );
};
